import {useEffect,useId,useRef} from 'react';

export function UploadCancelDialog({open,onConfirm,onClose}:{open:boolean;onConfirm:()=>void;onClose:()=>void}){
 const dialog=useRef<HTMLDialogElement>(null),title=useId(),description=useId(),previous=useRef<HTMLElement|null>(null);
 useEffect(()=>{
  if(open&&!dialog.current?.open){previous.current=document.activeElement instanceof HTMLElement?document.activeElement:null;dialog.current?.showModal();}
  if(!open&&dialog.current?.open){dialog.current.close();if(previous.current?.isConnected)previous.current.focus();}
 },[open]);
 return <dialog ref={dialog} className="ipad-library-delete-dialog upload-cancel-dialog" aria-labelledby={title} aria-describedby={description} onCancel={event=>{event.preventDefault();onClose();}} onClose={onClose}>
  <h3 id={title}>终止上传？</h3><p id={description}>将停止本次剩余文件的上传，并删除当前未完成的文件。已经完成上传的文件会保留。</p>
  <div><button type="button" autoFocus onClick={onClose}>继续上传</button><button type="button" className="ipad-library-destructive" onClick={onConfirm}>确认终止</button></div>
 </dialog>;
}
